/* wf-specs – specifikationstabell: förklaringar (i-knapp) och Visa alla/Visa färre. */
(function () {
  'use strict';

  function closeTip(btn) {
    var tip = document.getElementById(btn.getAttribute('aria-controls'));
    var row = btn.closest('.wf-specs__row');
    btn.setAttribute('aria-expanded', 'false');
    if (row) row.classList.remove('wf-specs__row--tip-open');
    if (tip) tip.hidden = true;
  }

  function openTip(btn) {
    var root = btn.closest('[data-wf-specs]');
    root.querySelectorAll('.wf-specs__info[aria-expanded="true"]').forEach(function (other) {
      if (other !== btn) closeTip(other);
    });
    var tip = document.getElementById(btn.getAttribute('aria-controls'));
    var row = btn.closest('.wf-specs__row');
    btn.setAttribute('aria-expanded', 'true');
    if (row) row.classList.add('wf-specs__row--tip-open');
    if (tip) tip.hidden = false;
  }

  function init(root) {
    if (root.dataset.wfSpecsReady) return;
    root.dataset.wfSpecsReady = '1';

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.wf-specs__info');
      if (btn && root.contains(btn)) {
        e.preventDefault();
        if (btn.getAttribute('aria-expanded') === 'true') closeTip(btn); else openTip(btn);
        return;
      }
      var toggle = e.target.closest('.wf-specs__toggle');
      if (toggle && root.contains(toggle)) {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        root.classList.toggle('wf-specs--collapsed', expanded);
        toggle.querySelector('.wf-specs__toggle-text').textContent = expanded ? toggle.dataset.show : toggle.dataset.hide;
        if (expanded) {
          var top = root.getBoundingClientRect().top;
          if (top < 0) root.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = root.querySelector('.wf-specs__info[aria-expanded="true"]');
      if (open) { closeTip(open); open.focus(); }
    });

  }

  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-wf-specs]').forEach(function (root) {
      if (root.contains(e.target)) return;
      root.querySelectorAll('.wf-specs__info[aria-expanded="true"]').forEach(closeTip);
    });
  });

  function boot() {
    document.querySelectorAll('[data-wf-specs]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
